<template>
  <div class="member__ai-tutor" v-if="activeTab !== 20">
    <div class="title">AI助教</div>
    <div class="ai-tutor__banner" @click="onClick">
      <img
        class="ai-tutor__img"
        referrerpolicy="no-referrer"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/member-ai.png"
        alt="AI助教"
      />
      <div class="ai-tutor__actions">
        <div class="ai-tutor__btn">批改{{ aiCorrectCount }}次</div>
        <div class="ai-tutor__btn">答疑{{ aiQuestionCount }}次</div>
      </div>
    </div>
  </div>
</template>

<script>
import { whatEev } from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { miniSchemeUrl } from '@/utils/common';

export default {
  props: {
    activeTab: {
      type: Number,
      default: 20,
    },
    aiCorrectCount: {
      type: Number,
      default: 0,
    },
    aiQuestionCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onClick() {
      if (this.$root.miniprogram) {
        wx.miniProgram.switchTab({ url: '/pages/home/home' });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: '/pages/home/home',
        });
      } else {
        this.getSchemeUrl();
      }
    },
    async getSchemeUrl() {
      const schemeLink = await miniSchemeUrl('wxdb89cfa2bb60f779', '/pages/home/home');
      window.location.href = schemeLink;
    },
  },
};
</script>

<style scoped lang="scss">
.member__ai-tutor {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 678px;
  margin: 0 auto 36px;
}

.title {
  width: 100%;
  margin-bottom: 22px;
  color: #333;
  font-weight: 500;
  font-size: 29px;
}

.ai-tutor__banner {
  position: relative;
  width: 678px;
}

.ai-tutor__img {
  display: block;
  width: 100%;
  height: auto;
}

.ai-tutor__actions {
  position: absolute;
  top: 33px;
  right: 43px;
}

.ai-tutor__btn {
  width: 199px;
  height: 62px;
  color: #fff;
  font-weight: 500;
  font-size: 24px;
  line-height: 62px;
  white-space: nowrap;
  text-align: center;
  background: linear-gradient(93deg, #DAC5F0 0%, #B393DC 100%);
  border-radius: 36px;

  & + & {
    margin-top: 12px;
  }
}
</style>
